import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { IOSSwitch } from "../Utility/iosSwitch";
import { Button, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";

const title =
  "Enabling this option will include data from the previous financial year where the reconciliation status is Matched but the 3B availed is status is blank.";

const useStyles = makeStyles(() => ({
  tooltip: {
    marginTop: "2px",
  },
}));

export default function SubHeader(props) {
  const classes = useStyles();
  const { activeTabReco, activeTabViewReco, activeTabDocView } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  return (
    <FormGroup>
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: "11px", fontWeight: "600" }}>
            Run reco <br />
            across financial Years
          </span>
          <FormControlLabel
            control={
              <IOSSwitch
                checked={props.runReco}
                onChange={props.handleRunReco}
                name="runReco"
              />
            }
          />
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: "11px", fontWeight: "600" }}>
            Run Fuzzy Logic
          </span>
          <FormControlLabel
            control={
              <IOSSwitch
                checked={props.runFuzzy}
                onChange={props.handleRunFuzzy}
                name="runFuzzy"
              />
            }
          />
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: "11px", fontWeight: "600" }}>
            Include <br />
            Non availed ITC
          </span>
          <Tooltip
            title={title}
            arrow
            classes={{
              tooltipPlacementTop: classes.tooltip,
              tooltipPlacementBottom: classes.tooltip,
              tooltipPlacementLeft: classes.tooltip,
              tooltipPlacementRight: classes.tooltip,
            }}
          >
            <FormControlLabel
              control={
                <IOSSwitch
                  checked={props.includeITC}
                  onChange={props.handleIncludeITC}
                  name="includeITC"
                />
              }
            />
          </Tooltip>
        </div>

        {activeTabReco === "1" && (
          <Button
            onClick={props.handleGenerateReport}
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "32px",
              marginTop: "1em",
              fontSize: "12px",
              marginLeft: "2em",
            }}
          >
            Generate Report
          </Button>
        )}

        {activeTabReco !== "1" && (
          <Button
            onClick={() => props.handleSubmit(true)}
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "32px",
              marginTop: "1em",
              fontSize: "12px",
              marginLeft: "2em",
            }}
          >
            Submit
          </Button>
        )}
      </div>
    </FormGroup>
  );
}
